"use client";

import { useProduct } from "@/contexts/ProductContext";
import { usePricing } from "@/contexts/PricingContext";
import { useSiteSettings } from "@/contexts/SiteSettingsContext";
import { cmsColorClass } from "@/utils/cmsColorClass";

const GalleryPromoOverlay = ({ visible = true }) => {
  const { selectedVariant } = useProduct();
  const pricing = usePricing();
  const { campaign } = useSiteSettings();

  // overlayPromo resolves the discount group once for both code and message,
  // falling back to promotionalCopy when custom_overlay_message isn't set in the CMS.
  const { code, message } = selectedVariant ? pricing.overlayPromo(selectedVariant) : {};
  if (!message || !code) return null;

  const barBackground = cmsColorClass(
    campaign?.campaign_banner?.settings?.background_color?.color_selector,
    "bg-primary",
  );

  return (
    // z-10 beats swiper's forced z-index:1 on .swiper-slide (mobile only; desktop has no swiper here).
    <div
      aria-hidden={!visible}
      className={`pointer-events-none absolute bottom-0 inset-x-0 z-10 flex h-13 items-center justify-center px-2 transition-opacity duration-300 max-[360px]:h-11 sm:h-14 sm:px-4 lg:h-16.25 2xl:h-20 ${barBackground} ${visible ? "opacity-100" : "opacity-0"}`}
    >
      {/* pointer-events-auto from lg up: desktop has no swiper/lightbox to protect here,
          so the pill lets the code be selected; mobile stays none so taps/swipes pass through. */}
      <div className="pointer-events-none lg:pointer-events-auto flex max-w-full flex-wrap items-center justify-center gap-x-3 gap-y-1 rounded-full bg-white px-3.5 py-2 font-worksans text-sm text-primary max-[360px]:gap-x-1.5 max-[360px]:px-2 max-[360px]:py-1 max-[360px]:text-[11px] sm:gap-x-4 sm:gap-y-1 sm:px-4 sm:py-2 sm:text-base 2xl:gap-x-6 2xl:px-6 2xl:py-3 2xl:text-lg">
        <span className="font-bold">{message}</span>
        <span className="font-normal">
          Discount Code: <span className="font-bold">{code}</span>
        </span>
      </div>
    </div>
  );
};

export default GalleryPromoOverlay;
